import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AgendaService {
  private apiUrl = environment.apiUrl;
  agendaUrl = `${this.apiUrl}public/agenda`;

  constructor(private _http: HttpClient) {
  }

  getAgendaUsuario(empresaId, usuarioId): Observable<any[]> {
    return this._http.get(`${this.agendaUrl}/${empresaId}/${usuarioId}`)
      .pipe(map(data => {
        return <any>data;
      }));
  }

  insertAtividade(atividade): Observable<any[]> {
    return this._http.post(`${this.agendaUrl}/${atividade.empresaId}/${atividade.usuarioId}`, atividade)
      .pipe(map(data => {
        return <any>data;
      }));
  }

  updateAtividade(atividade): Observable<any[]> {
    return this._http.patch(`${this.agendaUrl}/${atividade.empresaId}/${atividade.usuarioId}`, atividade)
      .pipe(map(data => {
        return <any>data;
      }));
  }

  removeAtividade(empresaId, usuarioId, atividadeId) {
    return this._http.delete(`${this.agendaUrl}/${empresaId}/${usuarioId}/${atividadeId}`)
      .pipe(map(data => {
        return <any>data;
      }));
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
